<template>
    <div id="billingForcastReport">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Billing Forecast Detail Report
                        <button type="submit" class="btn btn-success waves-effect pull-right" v-on:click.prevent="BackToPage">
                                Back
                        </button>
                    </div>
                    <div class="admin-page-content customer-detail">
                        <section class="internal-container">
                            <div class="container">
                                <form class="form-horizontal basic-form-container contract-mapper" id="ContractAssetDetailForm">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="col-md-12" style="margin-top:10px;">
                                                <span>Date:</span>
                                                <span><strong>{{ selectedDate }}</strong></span>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="control-label" for="contract_id">Customer:</label>
                                                <v-select v-model="customerId" name="customer_id"
                                                    label="text" :filterable="false" :options="customerArr"
                                                    @search="onSearchCustomer"
                                                    placeholder="Search Customer" class="custom-ci-auto-search contract-data">
                                                    <template slot="no-options">
                                                        Search Customer...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="control-label" for="contractTypeId">Contract Type:</label>
                                                <v-select class="section-id" v-model="contractTypeId" name="contractTypeId" placeholder="Select Contract Type"
                                                            label="text" :options="contractTypeArr">
                                                </v-select>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="control-label" for="location_id">Facility:</label>
                                                <v-select class="section-id" v-model="locationId" name="locationId" placeholder="Select Contract Type"
                                                            label="text" :options="locationArr">
                                                </v-select>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="control-label" for="sectionId">Section:</label>
                                                <v-select class="section-id" v-model="sectionId" name="sectionId" placeholder="Select Section"
                                                            label="text" :options="sectionArr">
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="col-sm-offset-6 col-sm-6">
                                                <input type="button" id="resetBtn" value="Reset" class="btn btn-primary nextBtn btn-lg pull-right" v-on:click="resetFilters">
                                                <input type="submit" id="searchBtn" :disabled="searchBtnDisabled" :value="searchBtnText" class="btn btn-primary nextBtn btn-lg pull-right" v-on:click.prevent="loadReport('filter')">
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <vue-good-table
                                    ref="billingForecastDetailReport"
                                    mode="remote"
                                    title="Billing Forecast Detail Report"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                        enabled: false,
                                    }">
                                </vue-good-table>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

// import EventBus from "./event-bus";
import Vue from "vue";


import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';








    export default {
        name: "billingForcastReport",
        mixins:[commonMixins,contractMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: true,
            searchBtnDisabled:false,
            searchBtnText:"Search",
            contractTypeArr:[],
            sectionArr:[],
            locationArr:[],
            customerArr:[],
            //vehicleArr:[],
            customerId: "",
            //unitId:"",
            contractTypeId:"",
            locationId:"",
            sectionId:"",
            billDate:"",
            selectedDate:"",
            columns: [
                {
                    label: 'Customer#',
                    field: 'custNo',
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Name',
                    field: 'custName',
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Type',
                    field: 'contType',
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Section',
                    field: 'section',
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Amount',
                    field: 'amount',
                    filterable: false,
                    type: "number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'No. Of Contract',
                    field: 'contCnt',
                    filterable: false,
                    type: "number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'No. Of Unit',
                    field: 'unitCnt',
                    filterable: false,
                    type: "number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Phone", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reading Required',
                    field: 'readReq',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Required", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }

            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            customer_value: false,
            loading:false,
            optionsDate:{
                            format: 'MM/DD/YYYY',
                            useCurrent: false,
                        },
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'billing_forecast_report') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            this.loadReport('list');
            this.loadFieldData(['contractType','location','section']);
        },
        methods: {

            BackToPage() {
                var self = this;
                self.$router.push("/billing-forecast/list");
            },

            resetFilters() {

                this.customerId = "";
                //this.unitId = "";
                this.contractTypeId = "";
                this.locationId = "";
                this.sectionId = "";
                this.loadReport('list');
            },
            onSearchCustomer(search, loading) {
                var self = this;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'customer', '');
                }
            },
            onSearchUnit(search, loading) {
                var self = this;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'vehicle', '');
                }

            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadReport('list');
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.serverParams.page = 1 ;
                this.loadReport('list');
            },

            onColumnFilter(params) {
                this.updateParams(params);
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                this.serverParams.page = 1 ;
                if (this.firstLoad == 1 || filters.name || filters.code || filters.description ) {
                    this.loadReport('list');
                }
            },

            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadReport('list');
            },

            loadReport(listFlag) {
                var self = this;

                var filterArr = {};
                if ( listFlag == 'filter' ) {

                    self.searchBtnText = "Searching...";
                    self.searchBtnDisabled = true;

                    if ( self.customerId != null && self.customerId.value ) {
                        filterArr['customer'] = self.customerId.value;
                    }
                    // if ( self.unitId != null && self.unitId.value ) {
                    //     filterArr['unit'] = self.unitId.value;
                    // }
                    if ( self.contractTypeId != null && self.contractTypeId.value ) {
                        filterArr['contractType'] = self.contractTypeId.value;
                    }
                    if ( self.locationId != null && self.locationId.value ) {
                        filterArr['location'] =  self.locationId.value;
                    }
                    if ( self.sectionId != null && self.sectionId.value ) {
                        filterArr['section'] =  self.sectionId.value;
                    }


                }
                if ( this.$route.query.date != null && this.$route.query.date != "" ) {
                    filterArr['date'] =  this.$route.query.date;
                }
                if ( this.$route.query.type != null && this.$route.query.type != "" ) {
                    filterArr['contractBillFreq'] =  this.$route.query.type;
                }

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: filterArr,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    listFlag:listFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/report/billing-forecast-detail",
                    type: "GET",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if ( listFlag == 'filter' ) {
                            self.searchBtnText = "Search";
                            self.searchBtnDisabled = false;
                        }
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.contentArr;
                            self.selectedDate = data.content.date;
                            // self.totalRecords = data.content.totalRecords;
                            // self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/reports/BillingForecastDetailReport.vue